import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';
import '../login/v3/login.scss';

export default function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [email, setEmail]     = useState('');
  const [msg, setMsg]         = useState('');
  const [error, setError]     = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setMsg('');
    setLoading(true);
    try {
      const { data } = await api.post('/auth/forgot-password', { email });
      setMsg(data.message);
    } catch (err) {
      setError(err.response?.data?.message || 'Something went wrong. Try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="v3-wrapper">
      <div className="v3-card" style={{ maxWidth: 440, minHeight: 'unset' }}>
        <div className="v3-right" style={{ flex: 1, padding: '48px 44px 36px' }}>
          <div className="v3-form-inner">
            <h2 className="v3-title">Forgot Password</h2>
            <p className="v3-subtitle">Enter your email address and we'll send you a reset link.</p>

            {error && <div className="v3-error">{error}</div>}
            {msg && (
              <div style={{ background: '#f0faf0', border: '1px solid #8bc34a', borderRadius: 8, padding: '10px 14px', fontSize: 13, marginBottom: 18, color: '#3a6b1e' }}>
                {msg}
              </div>
            )}

            {!msg && (
              <form onSubmit={handleSubmit} noValidate>
                <div className="v3-field">
                  <label>Email Address</label>
                  <div className="v3-input-wrap">
                    <span className="v3-input-icon">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                        <polyline points="22,6 12,13 2,6"/>
                      </svg>
                    </span>
                    <input
                      type="email"
                      placeholder="Enter your email"
                      value={email}
                      onChange={e => setEmail(e.target.value)}
                      required
                      autoComplete="email"
                    />
                  </div>
                </div>

                <button className="v3-btn-signin" type="submit" disabled={loading}>
                  {loading ? 'Sending…' : 'Send Reset Link'}
                </button>
              </form>
            )}

            <p style={{ textAlign: 'center', marginTop: 24, fontSize: 13 }}>
              <span
                style={{ color: '#8bc34a', cursor: 'pointer', fontWeight: 600 }}
                onClick={() => navigate('/login')}
              >
                ← Back to Sign In
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
